export type SiteSurface = 'public' | 'admin' | 'members'
export const siteAddresses = {
  public: 'https://lsceditorialboard.com',
  members: 'https://members.lsceditorialboard.com',
  admin: 'https://admin.lsceditorialboard.com',
  mail: 'https://mail.lsceditorialboard.com',
  publications: 'https://www.lasalle.edu.hk/publications/',
  instagram: 'https://www.instagram.com/lsceditorialboard/',
}

export function siteSurface(hostname: string): SiteSurface {
  if (hostname === 'lsceditorialboard.com' || hostname === 'www.lsceditorialboard.com') return 'public'
  if (hostname === 'admin.lsceditorialboard.com') return 'admin'
  return 'members'
}

export function isPublicPreviewLocation(hostname: string, pathname: string, development = false) {
  const projectPreview = /^edboard-26-27--[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.web\.app$/.test(hostname)
  return (development || projectPreview) && /^\/public(?:\/|$)/.test(pathname)
}

export const publicSitePreview = () => isPublicPreviewLocation(window.location.hostname, window.location.pathname, import.meta.env.DEV)

export function currentSiteSurface(): SiteSurface {
  if (publicSitePreview()) return 'public'
  // Local previews never change production hostname routing or authority.
  const preview = import.meta.env.DEV ? new URLSearchParams(window.location.search).get('site') : null
  if (preview === 'public' || preview === 'admin') return preview
  return siteSurface(window.location.hostname)
}
